const shouldDisplayDetailField = (key) => (
  typeof key === 'string'
  && key !== 'id'
  && !key.endsWith('_id')
  && key !== 'created_by'
  && key !== 'updated_by'
  && key !== 'created_on'
  && key !== 'updated_on'
);

export default shouldDisplayDetailField;
